import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import {
  convertThenFormat,
  formattedLongDate2,
} from "../../common-data/Converts";

const PendingPMLinkMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((lead, index) => {
          const totalPendings =
            lead?.payment_details_all?.length > 0 &&
            lead.payment_details_all.filter((val) => val?.status === "pending")
              .length;

          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name">{lead?.name || "NA"}</h3>

                  <span
                    className={`lead-type ${lead?.price}`}
                    style={{
                      backgroundColor: "#379C00",
                      color: "#fff",
                    }}
                  >
                    ₹{convertThenFormat(lead?.price || 0)}
                  </span>
                </div>

                <div className="card-other-info">
                  <span className="value semi-bold">
                    {lead?.mobile || ""}
                  </span>
                  <span className="value semi-bold">
                    {lead?.gym_name || ""}
                  </span>
                </div>

                <div
                  className="lead-multi-value-cols px20px pb20px"
                  style={{ marginTop: "10px" }}
                >
                  <div className="label-value">
                    <span className="label">Pending Amount</span>
                    <span className="value">
                      {" "}
                      ₹{convertThenFormat(lead?.total_pending || 0)}
                    </span>
                  </div>
                  <div className="label-value">
                    <span className="label">plan name</span>
                    <span className="value">
                      {lead?.plan_name?.replace(/_/g, " ") || "NA"}
                    </span>
                  </div>
                  <div className="label-value">
                    <span className="label">Date Added</span>
                    <span className="value">
                      {lead?.date_added
                        ? formattedLongDate2(lead.date_added)
                        : "-"}
                    </span>
                  </div>
                  <div className="label-value">
                    <span className="label">Payment Status</span>
                    <span className="value">{`${totalPendings} Pending`}</span>
                  </div>
                </div>

                <div className="all-btns lead-btn-axceed">
                  <div className="lead-log-box" style={{ width: "100%" }}>
                    <button
                      className="lead-log view-lead"
                      style={{
                        background: "#066CE3",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "partial-info",
                          partialInfo: lead?.payment_details_all,
                        }))
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        style={{
                          color: "#fff",
                        }}
                      >
                        <path
                          d="M16.9288 4.57227C24.1183 4.57227 30.0996 9.74528 31.3536 16.5723C30.0996 23.3992 24.1183 28.5723 16.9288 28.5723C9.73921 28.5723 3.75792 23.3992 2.50391 16.5723C3.75792 9.74528 9.73921 4.57227 16.9288 4.57227ZM16.9288 25.9056C22.5763 25.9056 27.4088 21.9749 28.632 16.5723C27.4088 11.1696 22.5763 7.23893 16.9288 7.23893C11.2812 7.23893 6.44868 11.1696 5.22543 16.5723C6.44868 21.9749 11.2812 25.9056 16.9288 25.9056ZM16.9288 22.5723C13.615 22.5723 10.9287 19.886 10.9287 16.5723C10.9287 13.2586 13.615 10.5723 16.9288 10.5723C20.2424 10.5723 22.9288 13.2586 22.9288 16.5723C22.9288 19.886 20.2424 22.5723 16.9288 22.5723ZM16.9288 19.9056C18.7697 19.9056 20.2621 18.4132 20.2621 16.5723C20.2621 14.7313 18.7697 13.2389 16.9288 13.2389C15.0879 13.2389 13.5954 14.7313 13.5954 16.5723C13.5954 18.4132 15.0879 19.9056 16.9288 19.9056Z"
                          fill="#fff"
                        />
                      </svg>
                    </button>

                    <span className="btn-label">View Payment Detials</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default PendingPMLinkMobile;
